import { CSS, Flex } from '@ghq-abi/design-system';

import { StatusBadge } from '~/entities/ManagerApproval/ui/elements/StatusBadge';

type ProfileBadgeProps = {
  color: string;
  status?: string;
  css?: CSS;
};
export function ProfileBadge({ color, status, css }: ProfileBadgeProps) {
  return (
    <Flex align="start" css={css}>
      <StatusBadge color={color} status={status} />
    </Flex>
  );
}
